import request from '@/utils/request'

// 分页查询活动列表
export function page(query) {
  return request({
    url: '/video/discount/list',
    method: 'get',
    params: query
  })
}

export function detail(query) {
  return request({
    url: `/video/discount/detail`,
    method: 'get',
    params: query
  })
}

export function add(data) {
  return request({
    url: '/video/discount/add',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: '/video/discount/update',
    method: 'post',
    data: data
  })
}

export function del(data) {
  return request({
    url: `/video/discount/del`,
    method: 'post',
    data: data
  })
}
